
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyDossierService } from "@/services/company-dossier-service";
import AppDossierEditForm from "../dossier/DossierEditForm.vue";
import AppRecreateStockOutsModal from "./RecreateStockOutsModal.vue";
import AppFixSaleActionsModal from "./FixSaleActionsModal.vue";
import AppRunSpecificMigrationModal from "./RunSpecificMigrationModal.vue";
import AppCreateQuickCopyModal from "./DossierEditQuickCreateCopyModal.vue";

export default Vue.extend({
	data(){
		return {
			recreateStockOutsModal: false,
			fixSaleActionsModal: false,
			runSpecificMigrationModal: false,
			createQuickCopyModalOpen: false
		};
	},
	props: {
		value: {
			type: Object as () => Dossier,
			required: true
		},
		company: {
			type: Object as () => Company,
			required: true
		},
	},
	methods: {
		async save() {
			let result = await CompanyDossierService.updateDossier(this.company.id, this.value);
			this.$wf.notify("Success", "success", 3000, "check");
			this.$emit("input", result);
		},
		async fixPartitions(){
			let confirm = await this.$wf.confirm("Weet je zeker dat je partities wilt gaan fixen?", "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await CompanyDossierService.fixPartitions(this.value.id);
		},
		async runMigrations(){
			let confirm = await this.$wf.confirm("Weet je zeker dat je migraties wilt runnen?", "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await CompanyDossierService.runMigration(this.value.id);
			this.$wf.notify("Migraties worden uitgevoerd", "info", 3000, "info");
		},
		async createMissingProducts(){
			let message = `Deze taak gaat alle verkoopdetail regels controlleren op ontbrekende artikelen. 
			Indien het artikel ontbreekt gaat die die aanmaken en op niet actief zetten.
			Wilt u verder gaan?`;
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await CompanyDossierService.createMissingProductsFromSaleRows(this.value.id);
			this.$wf.notify("Ontbrekende artikelen worden aangemaakt", "info", 3000, "info");
		},
		async createMissingExtraFields(){
			let message = `Deze taak gaat alle contact, artikelen, verkoopdocumenten en aankoopdocumenten nakijken 
				voor ontbrekende extra velden en kan lang duren. Weet je zeker dat je wilt verder gaan?`;
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await CompanyDossierService.createMissingExtraFields(this.value.id);
			this.$wf.notify("Extra velden worden aangemaakt", "info", 3000, "info");
		},
		async recomputeProductBuyPrices(){
			let message = "Deze taak gaat alle artikelen waarvan de aankoopprijs uit de samenstelling komt opnieuw berekenen. Wil je doorgaan?";
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await CompanyDossierService.recomputeProductBuyPrices(this.value.id);
			this.$wf.notify("Aankoopprijzen worden herberekend", "info", 3000, "info");
		},
		async deleteUnusedProducts(){
			let message = "Weet je zeker dat je alle ongebruikte artikelen wilt verwijderen?";
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "danger");
			if (!confirm) return;
			await CompanyDossierService.deleteUnusedProducts(this.value.id);
			this.$wf.notify("Ongebruikte artikelen worden verwijderd", "info", 3000, "info");
		},
		async createPriceListItemsOfAllProducts(){
			await CompanyDossierService.createPriceListItemsForAllProducts(this.value.id);
			this.$wf.notify("Prijslijst items worden aangemaakt voor alle artikelen", "info", 3000, "info");
		},
		async createPriceListItemsOfAllProductsAndDeleteUnused(){
			let message = "Weet je zeker dat je alle ongebruikte artikelen wilt verwijderen?";
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "danger");
			if (!confirm) return;
			await CompanyDossierService.createPriceListItemsForAllProductsAndDeleteUnused(this.value.id);
			this.$wf.notify("Ongebruikte artikelen worden verwijderd", "info", 3000, "info");
		},
		fixSaleActions(){
			this.fixSaleActionsModal = true;
		}
	},
	components: {
		AppDossierEditForm,
		AppRecreateStockOutsModal,
		AppFixSaleActionsModal,
		AppRunSpecificMigrationModal,
		AppCreateQuickCopyModal
	}
});
